import axiosIns from '@/libs/axios'

const ROOT_URL = '/Admin/data/suppliers'
export default {
  namespaced: true,
  state: {
    dataList: [],
    dataCounts: 0,
    dataItem: {
      id: null,
      company: null,
      name: null,
      phone: null,
      phone2: null,
      fax: null,
      email: null,
      notes: null,
      tax_office: null,
      tax_number: null,
      address: null,
      id_meets: null,
      id_countries: null,
      id_cities: null,
      related_persons: [
        {
          id: null,
          name: null,
          email: null,
          phone: null,
          related_person_types: null,
        },
      ],
      activities: [],
      sectors: [],
    },
    dataSave: {
      message: null,
      status: null,
      id: null,
    },
    phoneControl: {
      status: false,
      id: null,
    },
    filterData: {
      id_meets: null,
      id_countries: null,
      id_cities: null,
    },
    search: {
      keyword: null,
    },
    detailForm: false,
    detailSearch: false,
  },
  getters: {
    dataList(state) {
      return state.dataList
    },
    dataCounts(state) {
      return state.dataCounts
    },
    dataItem(state) {
      return state.dataItem
    },
    dataSaveStatus(state) {
      return state.dataSave
    },
    phoneControl(state) {
      return state.phoneControl
    },
    detailForm(state) {
      return state.detailForm
    },
    detailSearch(state) {
      return state.detailSearch
    },
    filterData(state) {
      return state.filterData
    },
    search(state) {
      return state.search
    },
  },
  mutations: {
    SET_DATA_LIST(state, data) {
      state.dataList = data
    },
    SET_DATA_ITEM(state, data) {
      state.dataItem = data
    },
    SET_DATA_COUNTS(state, data) {
      state.dataCounts = data
    },
    SET_DATA_SAVE(state, data) {
      state.dataSave = data
    },
    SET_PHONE_CONTROL(state, data) {
      state.phoneControl = data
    },
    SET_DETAIL_FORM(state, data) {
      state.detailForm = data
    },
    SET_DETAIL_SEARCH(state, data) {
      state.detailSearch = data
    },
    RESET_DATA_ITEM(state) {
      state.dataItem = {
        id: null,
        company: null,
        name: null,
        phone: null,
        phone2: null,
        fax: null,
        email: null,
        notes: null,
        tax_office: null,
        tax_number: null,
        address: null,
        id_countries: null,
        id_cities: null,
        related_persons: [
          {
            id: null,
            name: null,
            email: null,
            phone: null,
            related_person_types: null,
          },
        ],
        activities: [],
        sectors: [],
      }
    },
  },
  actions: {
    getDataList({ commit }, params) {
      const data = JSON.stringify(params)
      axiosIns
        .post(ROOT_URL, data)
        .then(response => {
          commit('SET_DATA_LIST', response.data.data)
          commit('SET_DATA_COUNTS', response.data.count)
        })
        .catch(error => console.error(error))
    },
    getDataItem({ commit }, id) {
      const data = JSON.stringify({
        where: {
          'suppliers.id': id,
        },
        array: false,
      })
      return axiosIns
        .post(ROOT_URL, data)
        .then(response => {
          commit('SET_DATA_ITEM', response.data.data)
          return response.data.data
        })
        .catch(error => console.error(error))
    },
    saveData({ commit }, postData) {
      const data = JSON.stringify(postData)
      axiosIns
        .post(`${ROOT_URL}/saveData`, data)
        .then(response => {
          commit('SET_DATA_SAVE', response.data)
        })
        .catch(error => console.error(error))
    },
    removeData({ commit }, id) {
      axiosIns
        .post(`${ROOT_URL}/deleteData`, { id })
        .then(response => {
          commit('SET_DATA_SAVE', response.data)
        })
        .catch(error => console.error(error))
    },
    /* Custom */
    getPhoneControl({ commit }, params) {
      axiosIns
        .post(`${ROOT_URL}/phoneControl`, params)
        .then(response => {
          commit('SET_PHONE_CONTROL', response.data)
        })
        .catch(error => console.error(error))
    },
  },
}
